import PlatformDashboard from "./PlatformDashboard";

/** Полная аналитика платформы (отдельная страница навигации). */
export default function PlatformAnalytics() {
  return <PlatformDashboard />;
}
